import { Base } from "components/template";
import { ProgressBar } from "components/molecules";
import { ListSalesChannels } from "components/organism";
import { useLocalStorage, useOnBoarding } from "_hooks";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "components/atoms";
import { useDispatch, useSelector } from "react-redux";
import { salesChannels } from "_config/store/onBoarding/onBoarding.thunk";

const prefix = "v-sales-channels";

const SalesChannels = () => {
  const dispatch = useDispatch();
  const [onBoarding, setOnBoarding] = useLocalStorage("onBoarding");
  const { state } = useLocation();
  const navigate = useNavigate();
  const { salesChannelsList, fetchMediaList } = useOnBoarding();
  const [selected, setSelected] = useState([]);
  const [country, setCountry] = useState();

  const {
    countries
  } = useOnBoarding();
  const { data: response, isLoading } = useSelector((s) => s.onBoarding.salesChannels);

  const onSubmit = (e) => {
    e.stopPropagation();
    dispatch(salesChannels(onBoarding?._id, {
      channelsKey: selected
    }));
  };

  const onToggle = (value) => {
    setSelected((s) => {
      let aux = [...s];
      let search = aux.indexOf(value)
      if (search !== -1) {
        aux.splice(search, 1);
      } else {
        aux.push(value);
      }
      return aux;
    });
  };

  useEffect(() => {
    setCountry(countries?.filter((c) => c.code === onBoarding?.step?.[1]?.countryKey)?.pop());
    fetchMediaList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (response !== null) {
      setOnBoarding(response);
      setTimeout(() => navigate("/account/complementaryData", { state }), 100);
    }
  }, [response]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Base
      align="normal"
      header={<ProgressBar max={6} progress={5} />}
      headerClass={"mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px] mt-10 mb-0"}
    >
      <div className={`${prefix} flex flex-wrap flex-col p-3 mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px]`}>
        <div className="flex flex-wrap flex-col gap-3 ">
          
          <p className="text-center text-3xl font-bold mx-auto mt-5 mb-2">Canales de venta</p>
          <p className="text-center text-base mx-auto mb-5">¿En dónde publicas tus productos?</p>

          {country?.code &&
            <ListSalesChannels 
              country={country?.title}
              flag={country?.code}
              elements={salesChannelsList?.filter((s) => s["country-code"] === country?.code).map(({key, name}) => ({
                key,
                content: name
              })) ?? []}
              onToggle={onToggle}
              selected={selected}
            />
          }

          <Button
            className="bg-primary text-white rounded-lg mt-5"
            disabled={!selected.length || isLoading}
            fullwidth
            spin={isLoading}
            pulse
            onClick={onSubmit}
          >Continuar</Button>
          
        </div>
      </div>
    </Base>
  );
};

export default SalesChannels;
